import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const UdyogAadharRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Udyog Aadhar Registration
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        The Udyog Aadhar Registration Certificate, issued under the MSME Act,
        2006, is a key document for micro, small, and medium enterprises (MSMEs)
        in India, previously known as MSME registration, now streamlined into an
        online process.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Regulatory Framework */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Regulatory Framework
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Udyog Aadhar registration, governed by the MSME Act, 2006, aims
            to support micro, small, and medium enterprises by enhancing their
            competitiveness, addressing unemployment and poverty, providing
            access to government schemes, and protecting them from financial
            pressures by larger industries.
          </p>

          {/* Eligibility Criteria */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Eligibility Criteria
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Udyog Aadhar registration is optional and applies to entities
            classified as micro, small, or medium enterprises based on investment
            in plant and machinery or equipment, as outlined below:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Micro Enterprises:</strong> Up to Rs. 25 lakhs
              (manufacturing) or Rs. 10 lakhs (services).
            </li>
            <li>
              <strong>Small Enterprises:</strong> Up to Rs. 5 crores
              (manufacturing) or Rs. 2 crores (services).
            </li>
            <li>
              <strong>Medium Enterprises:</strong> Up to Rs. 10 crores
              (manufacturing) or Rs. 5 crores (services).
            </li>
          </ul>

          {/* Application Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For proprietorships, the applicant’s Aadhar is mandatory, along with
            an email and mobile number. For partnerships, companies, or LLPs, the
            Aadhar of a partner, director, or designated partner is required.
            Applicants without Aadhar must enroll at an Aadhar center before
            proceeding.
          </p>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ol
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Access the Udyog Aadhar website.</li>
            <li>Enter the applicant’s 12-digit Aadhar for verification.</li>
            <li>
              Input the name matching the Aadhar, with mismatches leading to
              rejection.
            </li>
            <li>
              Specify the applicant’s caste, providing proof if SC/ST/OBC status
              is claimed.
            </li>
            <li>Enter the enterprise’s legal name and operating entity.</li>
            <li>
              Allow multiple registrations for applicants with multiple
              businesses.
            </li>
            <li>Select the legal entity type.</li>
            <li>
              Provide the PAN (proprietor’s for proprietorship, entity’s for
              LLP/company).
            </li>
            <li>Enter the business location details.</li>
            <li>
              Include the main and corporate office addresses, mobile, and email.
            </li>
            <li>Specify the business commencement date.</li>
            <li>Provide the previous MSME address if applicable.</li>
            <li>Enter bank details (IFSC code and account number).</li>
            <li>Identify the primary business activity.</li>
            <li>
              Select the relevant NIC code from the National Industrial
              Classification Handbook.
            </li>
            <li>Record the total number of employees.</li>
            <li>
              State the investment in machinery and equipment, excluding
              land/building values.
            </li>
            <li>Include District Industry Center details if required.</li>
          </ol>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            After submission, verify with an OTP and captcha. An acknowledgement
            number will be generated and emailed for future reference.
          </p>

          {/* Verification Steps */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Verification Steps
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Applicants must double-check all entered data before submission. The
            OTP verification process ensures authenticity, and the
            acknowledgement number serves as proof of application for tracking
            purposes.
          </p>

          {/* Entity Classification */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Entity Classification
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The registration caters to various entity types—proprietorships,
            partnerships, companies, and LLPs—each requiring specific Aadhar
            details of authorized individuals to complete the process.
          </p>

          {/* Operational Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Operational Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Businesses must ensure accurate data entry, including financial
            investments and employee counts, and maintain updated bank and
            address information to facilitate a smooth registration process.
          </p>

          {/* Concluding Overview */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Overview
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Udyog Aadhar registration streamlines MSME recognition in India,
            requiring careful adherence to the online application process and
            eligibility criteria to ensure compliance with the MSME Act, 2006.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UdyogAadharRegistration;